const namespace = 'month-view-page' as const;
const EVENT_ERROR_LOGGED = 'Flight Month View Error Logged' as const;
const MP_PROPERTY_ERROR = 'Flight Month View Error' as const;
const MP_PROPERTY_ERROR_INFO = 'Flight Month View Error Info' as const;
const MP_PROPERTY_ERROR_MESSAGE = 'Flight Month View Error Message' as const;

const GTM_EVENT_NAME = 'month_view_page_loaded' as const;

const STREVDA_CONTAINERS = {
  MOBILE_MPU: 'strevda-mobile-mpu',
  BANNER: 'strevda-banner',
  SIDEBAR: 'strevda-sidebar',
} as const;

const MONTH_VIEW_RHR_CTA_CONTAINER = 'month-view-rhr-cta-container' as const;

const TRACKING = {
  SCHEMAS: {
    EXPERIMENT_CHOKEPOINT_SCHEMA: 'experiment_choke_point.ExperimentChokePoint',
    SMART_METRIC_SCHEMA: 'experiment_smart_metrics.SmartMetric',
    EXPLORER_HOTELS_BTN_CLICKED_SCHEMA:
      'month_view_page.ExplorerHotelsBtnClicked',
    PAGE_LOAD_DIAGNOSTIC_SCHEMA: 'sandbox_coral.PageLoadDiagnostic',
  },
  MESSAGES: {
    EXPERIMENT_CHOKEPOINT: 'ExperimentChokePoint',
    SMART_METRIC: 'SmartMetric',
    EXPLORER_HOTELS_BTN_CLICKED: 'ExplorerHotelsBtnClicked',
    PAGE_LOAD_DIAGNOSTIC: 'PageLoadDiagnostic',
  },
} as const;

export {
  namespace,
  EVENT_ERROR_LOGGED,
  MP_PROPERTY_ERROR,
  MP_PROPERTY_ERROR_INFO,
  MP_PROPERTY_ERROR_MESSAGE,
  STREVDA_CONTAINERS,
  MONTH_VIEW_RHR_CTA_CONTAINER,
  GTM_EVENT_NAME,
  TRACKING,
};
